import React from 'react';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    BooleanInput,
    Create,
    required,
    SimpleForm,
    TextInput,
    useTranslate,
} from 'react-admin';

const WIDGET_CHOICES = [{ id: 'wallet', name: 'Wallet' }];

const TYPE_CHOICES = [
    { id: 'warranty', name: 'Warranty' },
    { id: 'expenses', name: 'Expenses' },
];

const WalletCategoryCreate = (props) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.wallet-category.name'),
            url: 'wallet-category',
            icon: <AccountBalanceWalletIcon />,
        },
        {
            text: translation('resources.wallet-category.create.name'),
            url: '',
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm redirect="list">
                    <ContainerFieldsList>
                        <CustomSelectInput
                            source="widget"
                            choices={WIDGET_CHOICES}
                            validate={[required()]}
                            label="Widget"
                        />
                        <CustomSelectInput
                            source="type"
                            choices={TYPE_CHOICES}
                            validate={[required()]}
                            label="Type"
                        />
                        <TextInput
                            source="code"
                            label="Code"
                            validate={[required()]}
                            helperText="Machine-readable identifier (e.g. groceries). Saved as lowercase."
                        />
                        <TextInput
                            source="name"
                            label="Name"
                            validate={[required()]}
                            helperText="Display name shown in the mobile app."
                        />
                        <TextInput
                            source="color"
                            label="Color (hex)"
                            validate={[required()]}
                            helperText="Hex color code for the donut chart (e.g. #4CAF50)."
                        />
                        <TextInput
                            source="icon"
                            label="Icon"
                            helperText="Icon identifier or URL used by the mobile app."
                        />
                        <BooleanInput
                            source="active"
                            label="Active"
                            defaultValue={true}
                        />
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};

export default WalletCategoryCreate;
